export enum BILLING_TARIFF_ALIAS {
  FREE = 'free',
  TEST = 'test',
  STATICA = 'statica',
}

export enum BILLING_TARIFF_PERIOD {
  MONTHLY = 'monthly',
  ANNUALLY = 'annually',
}
